module.exports = __webpack_public_path__ + "static/img/H7.5d45b314.jpg";